// 语言系统key
export const Key_i18n = 'mi_tob_dev_i18n';
// 语言系统默认值
export const Value_Default_i18n = 'en';
